export default __webpack_public_path__ + "static/media/calculatorLightOn.9bb42718.svg";